import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/plano";

/**
 * Classe de gerenciamento de chamadas da API dos Plano
 *
 * @class
 */
export default class PlanoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe PlanoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
 * @returns Lista de Plano (ComboBox)
 */
    listCbo(codOperadora: number, dataInicio?: string, dataFim?: string, itensPeriodo?: boolean) {
        // Define os parâmetros a serem enviados na requisição
        const parameters: { [key: string]: any } = {};

        // Adiciona os parâmetros de data, se definidos
        if (dataInicio) {
            parameters.dataInicio = dataInicio;
        }

        if (dataFim) {
            parameters.dataFim = dataFim;
        }

        // Define os parâmetros booleanos com valores padrão
        parameters.itensPeriodo = itensPeriodo ?? false;

        // Monta a URL com os parâmetros no formato correto
        const url = `${controller}/listar-planos-cbo/${codOperadora}/${parameters.itensPeriodo}`;

        // Faz a chamada à API
        return this.api<ApplicationModule[]>(url, {
            method: "GET",
            params: {
                dataInicio: parameters.dataInicio,
                dataFim: parameters.dataFim
            }
        });
    }

    /**
   * @returns registro do Plano Operadora
   */
    LerRegistro(codPlanoOperadora: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codPlanoOperadora }
        });
    }


}